import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import "./coinbase.css";
import { useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { featureSlides, revenueFeatures } from "./data";

const Coinbase = () => {
  // features
  const [isPrevWorksDisabled, setIsPrevWorksDisabled] = useState(true);
  const [isNextWorksDisabled, setIsNextWorksDisabled] = useState(false);

  const handleWorksChange = (WorksSwiper) => {
    setIsPrevWorksDisabled(WorksSwiper.isBeginning);
    setIsNextWorksDisabled(WorksSwiper.isEnd);
  };

  const [activeKeyIndex, setActiveKeyIndex] = useState(0);

  const handleKeyShow = (index) => {
    setActiveKeyIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <NewHead />

      <Helmet>
        <title>Coinbase Clone script development</title>

        <meta name="title" content="Coinbase Clone script development " />
        <meta
          name="description"
          content="Power your cryptocurrency exchange dream with our Coinbase clone script development service. Launch a secure and feature-rich platform to trade multiple cryptocurrencies seamlessly."
        />
        <meta
          property="og:title"
          content="Coinbase Clone script development "
        />
        <meta property="og:site_name" content="Beleaf Technologies" />
        <link
          rel="canonical"
          href="https://beleaftechnologies.com/coinbase-clone-script"
        />
      </Helmet>

      <main className="cb_main">
        {/* hero */}
        <article className="cb_hero cb_mb_80">
          <div className="primary__landing-content-container">
            <h1 className="cb_title">Coinbase Clone Script Development</h1>
            <p className="cb_content">
              Unlock the potential of the cryptocurrency market with our
              expertly crafted Coinbase clone script, a secure and scalable
              solution for seamless exchange development. Accelerate your
              business growth and stay ahead in the crypto revolution.
            </p>
            <div className="text-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="cb_btn"
              >
                Get Free Consultation
              </button>
            </div>

            <div className="text-center">
              <img
                src="https://res.cloudinary.com/djcn5wxkj/image/upload/v1777353659/cb_hero_xi7y7e_1_hyxio2.webp"
                alt="Coinbase Clone Script Development"
                className="cb_hero_img"
                loading="lazy"
              />
            </div>
          </div>
        </article>

        {/* about */}
        <article className="primary__landing-content-container cb_mb_100">
          <div className="cb_about">
            <h3 className="cb_subtitle cb_abt_title">
              <span className="cb_span">What is </span>
              Coinbase Clone Script?
            </h3>
            <p className="cb_abt_content ">
              A Coinbase clone script is a pre-built solution script that mimics
              the essential features of the popular cryptocurrency exchange,
              Coinbase. This script allows you to kickstart your own exchange
              platform with features like user registration, wallet creation,
              buying/selling of cryptocurrencies, transaction history, security
              protocols, and more. It serves as a solid foundation for your
              exchange, saving you time, resources, and development costs.
            </p>
            <div className="text-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="cb_btn"
              >
                Get Demo <i className="fa-solid fa-arrow-right ml-2"></i>
              </button>
            </div>
          </div>
        </article>

        {/* benefits */}
        <article className="primary__landing-content-container cb_mb_100">
          <h3 className="cb_subtitle cb_ben_title">
            <span className="cb_span">Benefits of </span>
            Using Coinbase Clone Script
          </h3>

          <div className="row mx-0 g-4 cb_ben_row">
            <div className="col-lg-5 col-sm-6">
              <div className="cb_ben_card">
                <div className="text-center">
                  <img
                    src="https://res.cloudinary.com/djcn5wxkj/image/upload/v1777353753/ben_img_one_j3jaqg_1_zbnyyv.webp"
                    alt="Coinbase Clone Script Development"
                    loading="lazy"
                    className="cb_ben_img_one"
                  />
                </div>

                <div className="cb_ben_card_content">
                  <h5>Time Efficiency</h5>
                  <p>
                    Developing a crypto exchange from scratch can be
                    time-consuming. With a Coinbase clone script, you can
                    significantly reduce the development time and launch your
                    platform faster.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-sm-6">
              <div className="cb_ben_card">
                <div className="cb_ben_card_content">
                  <h5>Customization</h5>
                  <p>
                    While clone scripts provide a basic framework, they are
                    highly customizable. You can add unique features,
                    incorporate different cryptocurrencies, and tailor the
                    platform to suit your target audience.
                  </p>
                </div>
                <div className="cb_ben_img_two_wrap">
                  <img
                    src="https://res.cloudinary.com/djcn5wxkj/image/upload/v1777357880/ben_img_two_ivyvea_1_zpkkaf.webp"
                    alt="Coinbase Clone Script Development"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="cb_ben_card">
                <div className="cb_ben_bt_img_three">
                  <img
                    src="https://res.cloudinary.com/djcn5wxkj/image/upload/v1777353834/ben_img_three_egnpjc_1_th1roh.webp"
                    alt="Coinbase Clone Script Development"
                    loading="lazy"
                  />
                </div>

                <div className="cb_ben_card_content">
                  <h5>Security & Reliability</h5>
                  <p>
                    Coinbase clone scripts are often developed by experienced
                    professionals with a strong focus on security. This ensures
                    that your exchange platform will have robust security
                    measures, protecting your users' funds and data.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="cb_ben_card">
                <div className="cb_ben_bt_img_four">
                  <img
                    src="https://res.cloudinary.com/djcn5wxkj/image/upload/v1777354034/ben_img_four_yku4qs_1_wc0ngx.webp"
                    alt="Coinbase Clone Script Development"
                    loading="lazy"
                  />
                </div>

                <div className="cb_ben_card_content">
                  <h5>Cost-Effective</h5>
                  <p>
                    Custom development of a crypto exchange can be expensive. By
                    utilizing a clone script, you eliminate the need for
                    starting from the ground up, resulting in substantial cost
                    savings.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="cb_ben_card">
                <div className="cb_ben_bt_img_four">
                  <img
                    src="https://res.cloudinary.com/djcn5wxkj/image/upload/v1777354380/ben_img_five_uewojg_1_gd7ca2.webp"
                    alt="Coinbase Clone Script Development"
                    loading="lazy"
                  />
                </div>

                <div className="cb_ben_card_content">
                  <h5>User-Friendly Interface</h5>
                  <p>
                    Coinbase clone scripts usually come with an intuitive user
                    interface, making it easy for both novice and experienced
                    users to navigate the platform smoothly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* features */}
        <article className="primary__landing__container">
          <div className="cb_feature">
            <h3 className="cb_subtitle cb_fe_title">
              <span className="cb_span">Features Of </span>
              Our Coinbase Clone Script
            </h3>

            <>
              <Swiper
                className="en_bk_process_swiper"
                modules={[Navigation]}
                navigation={{
                  prevEl: ".cr_doc_prev",
                  nextEl: ".cr_doc_nxt",
                }}
                breakpoints={{
                  320: { slidesPerView: 1, spaceBetween: 10 },
                  576: { slidesPerView: 2, spaceBetween: 20 },
                  768: { slidesPerView: 2, spaceBetween: 30 },
                  992: { slidesPerView: 3, spaceBetween: 20 },
                  1200: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                    slidesPerGroup: 4,
                  },
                }}
                onSlideChange={handleWorksChange}
                onReachBeginning={() => setIsPrevWorksDisabled(true)}
                onReachEnd={() => setIsNextWorksDisabled(true)}
                onFromEdge={() => {
                  setIsPrevWorksDisabled(false);
                  setIsNextWorksDisabled(false);
                }}
                speed={500}
              >
                {featureSlides.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="cb_fe_card">
                      <img
                        src={item.img}
                        alt="Coinbase Clone Script Development"
                        loading="lazy"
                      />
                      <div className="cb_fe_cd_content">
                        <h5>{item.title}</h5>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              <div className="fd-step-btn-wrap">
                <button
                  className={`en_bk_process_btn cr_doc_prev ${
                    isPrevWorksDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevWorksDisabled ? "#9c63ee6e" : "#975dee",
                    cursor: isPrevWorksDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <i className="fa-solid fa-angle-left"></i>
                </button>
                <button
                  className={`en_bk_process_btn cr_doc_nxt ${
                    isNextWorksDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextWorksDisabled ? "#9c63ee6e" : "#975dee",
                    cursor: isNextWorksDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <i className="fa-solid fa-angle-right"></i>
                </button>
              </div>
            </>
          </div>
        </article>

        {/* revenue */}
        <article className="primary__landing__container cb_mb_100">
          <div className="cb_revenue">
            <div className="row mx-0 g-3">
              <div className="col-lg-5">
                <h3 className="cb_subtitle cd_rev_title">
                  <span className="cb_span">Revenue Factors in </span>
                  Our Coinbase Clone Script
                </h3>
              </div>

              <div className="col-lg-7">
                <div className="cb_rev_wrap">
                  {revenueFeatures.map((feature, index) => (
                    <div className="cb_rev_card" key={index}>
                      <div
                        className="cb_rev_top"
                        onClick={() => handleKeyShow(index)}
                      >
                        <span>
                          <img
                            src={feature.image}
                            alt="Coinbase Clone Script Development"
                            loading="lazy"
                          />
                          <h5 className="cb_rev_cd_title">{feature.title}</h5>
                        </span>
                        <span className="cb_rev_icon">
                          {activeKeyIndex === index ? (
                            <i className="fa-solid fa-xmark"></i>
                          ) : (
                            <i className="fa-solid fa-plus"></i>
                          )}
                        </span>
                      </div>

                      {activeKeyIndex === index && (
                        <p className="cb_rev_cd_content">
                          {feature.description}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* launch */}
        <article className="primary__landing-content-container">
          <div className="cb_launch">
            <h3 className="cb_subtitle text-center">
              <span className="cb_span">Launch Your Own Exchange!</span>
            </h3>
            <p className="cb_lnch_content ">
              Once you've acquired the Coinbase clone script, the next steps
              involve setting up the necessary infrastructure, configuring the
              script, and testing the platform thoroughly. Ensure that you
              comply with legal and regulatory requirements related to
              cryptocurrency exchanges in your jurisdiction.
            </p>

            <div className="d-flex justify-content-center align-items-center">
              <div
                data-toggle="modal"
                data-target="#myModal"
                className="cb_launch_btn_outer"
              >
                <button className="cb_launch_btn">
                  <img
                    src={require("../../../image/CoinbaseNew/launch-icon.webp")}
                    alt="Coinbase Clone Script Development"
                    className="mr-3"
                    loading="lazy"
                  />
                  Launch
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* Take Away*/}
        <article className="rs-mt-100 custom-get-in-touch ply-ta">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title dt-get-title">
              Take Away
            </h5>
            <p className="custom-get-content dt-get-content">
              Once you've acquired the Coinbase clone script, the next steps
              involve setting up the necessary infrastructure, configuring the
              script, and testing the platform thoroughly. Ensure that you
              comply with legal and regulatory requirements related to
              cryptocurrency exchanges in your jurisdiction.
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-4 re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </article>
      </main>

      <ServiceFooter />
    </>
  );
};

export default Coinbase;
